module.exports = __webpack_public_path__ + "images/LOGO.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LOGO.png
// module id = 954
// module chunks = 2